import React, { useEffect } from "react";
import Navbar from "../ui-components/LandingPage/CommonUi/Navbar";
import Footer from "../ui-components/LandingPage/CommonUi/Footer";
import { Outlet } from "react-router-dom";
import SLFooter from "../ui-components/LandingPage/CommonUi/SLFooter";
import Sample from "../ui-components/LandingPage/CommonUi/Sample";
import Intercom from "@intercom/messenger-js-sdk";

const Layout = () => {
  useEffect(() => {
    Intercom({
      app_id: process.env.REACT_APP_INTERCOM_APP_ID,
      hide_default_launcher: false,
    });
  }, []);

  return (
    <div className="text-black">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Sample />
      <SLFooter />
      <Footer />
    </div>
  );
};

export default Layout;
